const TravelPlannerBrands = {
  otp2: "OTP",
  9292: "9292",
};

export default TravelPlannerBrands;



// WEBPACK FOOTER //
// ./src/enums.js